import React, { Fragment } from 'react';
import { injectIntl } from 'react-intl';
import { compose } from 'recompose';

import {
  withStyles,
  Menu,
  MenuItem,
} from '@material-ui/core';

import { Checkbox } from 'shared/components';
import withPopover from 'shared/hocs/withPopover';
import { FilterIconWithHint } from 'modules/queues/common/components/AppointmentsFilter';

const FilterByAppointmentStatus = ({
  anchorEl,
  openPopover,
  closePopover,

  fields,
  appointmentStatuses,
  iconTooltipMessage,
  setFilterByAppointmentStatus,

  classes,
}) => {
  let firstCheckboxRef = null;
  const setFirstCheckboxRef = el => firstCheckboxRef = el;

  return (
    <Fragment>
      <FilterIconWithHint
        openPopover={ openPopover }
        popoverOpened={ !!anchorEl }
        activeFilters={ appointmentStatuses }
        iconName="clock-outline"
        iconTooltipMessage={ iconTooltipMessage }
      />

      <Menu
        MenuListProps={{ role: '', component: 'div' }}
        anchorEl={ anchorEl }
        open={ !!anchorEl }
        onClose={ closePopover }
        onEntered={ () => { firstCheckboxRef.focus(); } }
        getContentAnchorEl={ null }
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PopoverClasses={{
          paper: classes.topArrow,
        }}
      >
        { fields.map(({ key, label }, index) => (
          <MenuItem
            tab-index={ -1 }
            role="checkbox"
            aria-label={ intl.formatMessage(label) }
            aria-checked={ appointmentStatuses.includes(key) }
            key={ key }
            onClick={ (e) => (e.key === ' ' || e.key === 'Spacebar') && setFilterByAppointmentStatus(key) }
            component="div"
          >
            <Checkbox
              inputRef={ (ref) => { if (index === 0) setFirstCheckboxRef(ref); } }
              checked={ appointmentStatuses.includes(key) }
              onClick={ () => setFilterByAppointmentStatus(key) }
              label={ label }
            />
          </MenuItem>
        )) }
      </Menu>
    </Fragment>
  );
};

export default compose(
  injectIntl,
  withPopover(),
  withStyles(({ topArrow }) => ({ topArrow })),
)(FilterByAppointmentStatus);
